/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BoostTier3Icon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAByklEQVR4nLVVvUoDQRBOpRamsxAtFCsLrXwALYPJzoyBzUyuMI3Rwl6xkdTiC+QhFHwBK7ESbdRKBLGws/IHFFTmcns5k7skZ86BgbvZ2e/b+XZ3NpfLwAAgb4gv1K21438CQeQVILlXL65VFn6PVbeA5FsdsbqRfoVrsm2QP1og/ILoLbqx5VptzKDcOgJDcqOxgYCttSNA0gwmfxmUg1K5Ou+TAuSBpK6ADjwkQbk1xJuakwheKlUnDMmpPwn5HaCyHh03xFedwF1ExJex4Ig8CyQPrdXwI5G31JkzFIEhPglWfr5q7WQYR95VdxKpDHESAfG1ypcoEZC8+okgUxHwRltjbrh4oVAYDQDDTdZYovYBgZ/crkj2usuXvUh+PSLLZk/wWAKUt5iT8hbmt+S6VO95cpIIIGET+wJlRYB66gZZ+V8JjH/L+fnfCCCtZINtMn9kR0B9j2lKApQnnVAs2ul2Fbwbuan7Lq45rsumITiKbxWyo+7+dUxzggt2PDBBsezN9Wt2RN6SjgVVPayWvZlcGuvVrg1JJexXKGfRKlNZ54MDxIct128/1tSc3LBmtC2HT6bvn65tZ2b66BuUO3X9zhR8GPsBAbaaeHaqRGYAAAAASUVORK5CYII=)
 */
export const BoostTier3Icon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M13.19 2.5c.29-.24.35-.7.06-.94l-.2-.16a1.59 1.59 0 0 0-2.1 0l-4.9 4A3.37 3.37 0 0 0 5 8v8c0 1.07.4 2.06 1.05 2.6l4.9 4c.65.53 1.45.53 2.1 0l4.9-4A3.37 3.37 0 0 0 19 16v-3.5c0-.28-.23-.5-.5-.54-.2-.03-.4-.08-.6-.15-.4-.14-.9.12-.9.54V16c0 .65-.25 1-.32 1.05l-4.36 3.57a.5.5 0 0 1-.64 0l-4.36-3.57C7.25 16.99 7 16.65 7 16V8c0-.65.25-1 .32-1.05l4.52-3.7c.1-.07.23-.07.32 0 .12.1.3.06.39-.07.17-.25.38-.49.64-.69Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="m9.3 8.7 2.35-2.35c.2-.2.5-.2.7 0l2.36 2.36a1 1 0 0 1 .29.7v5.18a1 1 0 0 1-.3.7l-2.35 2.36a.5.5 0 0 1-.7 0l-2.36-2.36a1 1 0 0 1-.29-.7V9.4a1 1 0 0 1 .3-.7ZM17.86.8a1.21 1.21 0 0 1 2.28 0l.5 1.37a2 2 0 0 0 1.19 1.18l1.38.51a1.21 1.21 0 0 1 0 2.28l-1.38.5a2 2 0 0 0-1.18 1.19l-.51 1.38a1.21 1.21 0 0 1-2.28 0l-.5-1.38a2 2 0 0 0-1.19-1.18l-1.38-.51a1.21 1.21 0 0 1 0-2.28l1.38-.5a2 2 0 0 0 1.18-1.19l.51-1.38Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
